import { isEmpty } from '../misc';

// TODO: Remove this and use the one from smoothie once we update existing phone input components
export const VALID_PHONE_NUMBER_MASK = /\(\d{3}\) \d{3}-\d{4}/;
export const PHONE_NUMBER_MASK = [
    `(`,
    /\d/,
    /\d/,
    /\d/,
    ')',
    ' ',
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];

export const VALID_SSN_MASK = /\d{3}-\d{2}-\d{4}/;
export const SSN_MASK = [
    /\d/,
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    '-',
    /\d/,
    /\d/,
    /\d/,
    /\d/,
];

/**
 * Adapted from source code in react-native-mask-input here: https://github.com/CaioQuirinoMedeiros/react-native-mask-input
 * The input from that package is not flexible enough for styling, so we're just adapting the masking code here to be used with our own input components.
 */
export const formatWithMask = (
    mask: Array<string | RegExp>,
    text: string,
): { masked: string; unmasked: string } => {
    if (isEmpty(text)) return { masked: '', unmasked: '' };

    let masked = '';
    let unmasked = '';

    let maskCharIndex = 0;
    let valueCharIndex = 0;

    while (true) {
        // if mask is ended, break.
        if (maskCharIndex === mask.length || valueCharIndex === text.length) {
            break;
        }

        const maskChar = mask[maskCharIndex];
        const valueChar = text[valueCharIndex] as string;

        // if value is ended, break.
        if (valueCharIndex === text.length) {
            if (typeof maskChar === 'string') {
                masked += maskChar;
                maskCharIndex += 1;
                continue;
            }
            break;
        }

        // value equals mask: add to masked result and advance on both mask and value indexes
        if (maskChar === valueChar) {
            masked += maskChar;
            valueCharIndex += 1;
            maskCharIndex += 1;
            continue;
        }

        const unmaskedValueChar = text[valueCharIndex];

        // it's a regex maskChar: let's advance on value index and validate the value within the regex
        if (typeof maskChar === 'object') {
            // advance on value index
            valueCharIndex += 1;

            // value match regex: add to masked and unmasked result and advance on mask index too
            if (RegExp(maskChar).test(valueChar)) {
                masked += valueChar;
                unmasked += unmaskedValueChar;
                maskCharIndex += 1;
            }
        } else {
            // it's a fixed maskChar: add to maskedResult and advance on mask index
            masked += maskChar;
            maskCharIndex += 1;
        }
    }

    return { masked, unmasked };
};
